import {
  tryLoadDependencies,
  WebAwesomeComponent,
} from '@/components/webcomponents/Global/loadDependency'
import { getTemplateNavHeaderUtilityStyles } from './NavHeaderUtility.styles'

const t = document.createElement('template')
t.innerHTML = `
  <wa-button size="small">
    <slot></slot>
    <slot name="buttonText"></slot>
  </wa-button>
`

class NavHeaderUtilityButton extends HTMLElement {
  private waButton!: HTMLElement | null

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Button, WebAwesomeComponent.Icon])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderUtilityStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))

    this.waButton = null
  }

  static get observedAttributes() {
    return ['href']
  }

  attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null) {
    if (name === 'href' && oldValue !== newValue) {
      this.applyHref()
    }
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('NavHeaderUtilityButton connectedCallback', this)

    this.waButton = this.shadowRoot!.querySelector('wa-button')

    this.applyHref()
  }

  disconnectedCallback() {}

  private applyHref() {
    if (!this.waButton) return

    const href = this.getAttribute('href')

    if (!href) {
      this.waButton.removeAttribute('href')
      return
    }
    this.waButton.setAttribute('href', href)
  }
}

if (!customElements.get('ts-navheader-utility-button')) {
  customElements.define('ts-navheader-utility-button', NavHeaderUtilityButton)
}
export { NavHeaderUtilityButton }
